import type { SiteContextModeEnum } from '@/enums/SiteContextModeEnum'
import type { UnpackedSanityPage } from '@/lib/queries/sanityQueryStrings'

export function getPageFromSanityPages(
  pages: UnpackedSanityPage[],
  siteContext: SiteContextModeEnum,
  language: string
): UnpackedSanityPage | undefined {
  return pages.find((page) => {
    if (!page.sites || page.sites.length === 0) {
      return false
    }

    return page.sites.find((site) => site.includes(siteContext)) && page.language === language
  })
}
